import { connect } from 'react-redux';
import { getIsFavourite } from '../../../../CollectionPanel/redux/selectors';
import { getHasCommentedOnDeviation } from '../../../../redux/deviations/selectors';
const mapStateToProps = (state, { deviation  })=>{
    return {
        isFaved: getIsFavourite(state, deviation),
        hasCommentedOn: getHasCommentedOnDeviation(state, deviation)
    };
};
export default connect(mapStateToProps);
